<template>
<div class="pt-2 text-start text-white">
    เอกสาร : <b> {{curRecordHd.RONo}} </b> ชื่อ : <b>{{curRecordHd.PatName}}</b> นามสกุล : <b>{{curRecordHd.PatLName}}</b> <br>
    หมายเหตุ : {{curRecordHd.Remark}}
    <!-- <form @submit.prevent=""> -->
        <table id="myAppvResultTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
            <thead class="text-white" style="background:Navy">
            <tr>
                <th>ชุดตรวจ</th>
                <th>เทส</th>
                <th>เครื่องหมาย</th>
                <th>ผลแล็บ</th>
                <th>MIN / MAX</th>
                <th title="Repeat Checked">R</th>
                <th>หน่วย</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in datalists" :key="item.RODtl2ID" class="table-light">
                <!-- id และ ValueType : สำหรับใช้เป็น key ในการบันทึกผลและแยกประเภทข้อมูลแต่ละเทส -->
                <input type="text text-info" hidden class="form-control my-edit-input" name="id" :value="item.RODtl2ID">
                <input type="text text-info" hidden class="form-control my-edit-input" name="ValueType" :value="item.ValueType">

                <td class="text-start "><span style="font-size:80%">({{ item.TestCode }}) </span> <span class="text-danger" style="font-size:80%;" v-if="item.PropackName"> {{item.PropackName}} </span></td>
                <td class="text-start " v-if="(item.PrintUL==0)"> &nbsp; {{ item.ItemTestName }}</td>
                <td class="text-start " v-else><b>{{ item.ItemTestName }}</b> </td>
                <td class="text-start px-3" style="width:100px;">  {{item.PrefixResult}}    </td>
                <td class="text-start text-primary" v-if="item.ValueType == 0"><b>{{ Number(item.Result).toFixed(item.Decimals) }}</b> </td>
                <td class="text-start text-primary" v-if="item.ValueType == 1"><b>{{ item.ResultText }}</b> </td>
                <td class="text-start text-primary" v-if="item.ValueType == 2"><b>{{ item.Result }}</b> </td>
                <td style="width:100px;" > {{item.MinValue}} / {{item.MaximumValue}} </td>
                <td class="text-center" style="width:30px;" title="Repeat Checked"> {{ arrRepeatChk[datalists[index].RepeatChecked] }}
                </td>
                <td class="text-start">{{ item.Unit }} </td>
            </tr>
            </tbody>
        </table>
    <!-- </form> -->
    <!-- <button class="btn btn-success" v-if=" curRecordHd.Status == 2" @click="approveRecord()">ยืนยันผลแล็บ</button> -->
    <br>
</div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// // ****** Bootstrap and jQuery libraries ******
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// // ****** Datatable Modules *******
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    return {
      globalBranchID, globalUserID, globalUserName
    }
  },
  name: 'LabPrint2Dtl',
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      datalists: null,
      curRecordHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PatName: '',
        PatLName: '',
        IDNo: '',
        ReqClinicID: 0,
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        Remark: '',
        TotalAmt: 0.0,
        DiscRate: 0.0,
        DiscAmt: 0.0,
        TotalAmt_BfVat: 0.0,
        VatRate: 0.0,
        VatAmt: 0.0,
        NetAmt: 0.0,
        PayType: 0,
        EarnestAmt: 0.0,
        Status: 0
      }
    }
  },
  props: ['dataROHead'],
  mounted () {
    // console.log(this.dataROHead)
    if (this.dataROHead == null) {
    } else {
      this.curRecordHd.ROID = this.dataROHead.ROID
      this.curRecordHd.RONo = this.dataROHead.RONo
      this.curRecordHd.PatName = this.dataROHead.PatName
      this.curRecordHd.PatLName = this.dataROHead.PatLName
      this.curRecordHd.IDNo = this.dataROHead.IDNo
      this.curRecordHd.Sex = this.dataROHead.Sex
      this.curRecordHd.Status = this.dataROHead.Status
      this.curRecordHd.Remark = this.dataROHead.Remark
      this.getLabResultData()
    }
  },
  components: {

  },
  methods: {
    getLabResultData () {
      // MyApiClient.get('getdata/labrequest_all.php')
      MyApiClient.get('getdata/labresult_where.php?id=' + this.curRecordHd.ROID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
        //   setTimeout(function () { $('#myEntryResultTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
